import { AxiosResponse } from 'axios';
import { auth } from '@/shared/infrastructure/clients';
import type {
  SigninRequest,
  SigninResponseSuccess,
  SigninResponseError,
} from '@/shared/infrastructure/clients';

const signin = async (
  credentials: SigninRequest,
): Promise<AxiosResponse<SigninResponseSuccess | SigninResponseError>> =>
  auth().signin(credentials);

export { signin };
